(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/prolongation/assets/javascripts/views/prolongation.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/prolongation/assets/javascripts/views/prolongation.js');

'use strict';

svs.eurojackpot.components.prolongation.views.Prolongation = Marionette.View.extend({
  regions: {
    prolongationContentRegion: '#prolongationContentRegion'
  },
  template(data) {
    return svs.eurojackpot.components.prolongation.templates.prolongation(data);
  },
  async onRender() {
    const syndicates = await svs.numbergames.accountSelector.getAccounts();
    this.showChildView('prolongationContentRegion', new svs.numbergames.prolongation.views.Prolongation({
      productId: svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT,
      syndicates
    }));
  }
});

 })(window);